import { Button } from '@/components/ui/button'
import { useRefresh } from '@/hooks/refresh'
import { cn } from '@/lib/utils'
import { RoutePaths } from '@/routes'
import { useWallet } from '@trinity/wallet-react'
import { type FC, useCallback, useState } from 'react'
import { MdRefresh } from 'react-icons/md'
import { useMatch } from 'react-router-dom'
import { ConnectedWalletButton } from './connected-wallet-button'
import { ConnectWalletDialog } from './dialog/connect-wallet'
import { OnboardingDialog } from './dialog/onboarding'

interface Props {
    className?: string
}

export const Header: FC<Props> = ({ className }) => {
    const { isReady, isConnected, connect } = useWallet()
    const [isOnboardingOpen, setIsOnboardingOpen] = useState(false)

    const handleConnect = useCallback(() => {
        setIsOnboardingOpen(true)
    }, [])

    const onOnboardingFinish = useCallback(() => {
        setIsOnboardingOpen(false)
        connect()
    }, [connect])

    const adminRouteMatch = useMatch({ path: RoutePaths.AdminHome, end: false })
    const shouldShowRefreshAction = adminRouteMatch !== null

    const { refresh, isRefreshing } = useRefresh()

    if (!isReady) {
        return null
    }

    return (
        <header className={cn('justify-end flex flex-row gap-4', className)}>
            {shouldShowRefreshAction && (
                <Button
                    variant="outline"
                    onClick={refresh}
                    disabled={isRefreshing}
                    className="flex items-center gap-1.5"
                >
                    <MdRefresh className={cn({ 'animate-spin': isRefreshing })} />
                    <span>Refresh</span>
                </Button>
            )}
            {isConnected ? <ConnectedWalletButton /> : <ConnectWalletDialog onConnect={handleConnect} />}
            <OnboardingDialog
                onOpenChange={setIsOnboardingOpen}
                open={isOnboardingOpen}
                onFinish={onOnboardingFinish}
            />
        </header>
    )
}
